import { useState, useEffect } from 'react'
import { FiPlus, FiTrash2, FiZap, FiArrowRight, FiDatabase, FiSearch } from 'react-icons/fi'
import toast from 'react-hot-toast'
import api from '../utils/api'

const RELATION_TYPES = [
  { value: 'many_to_one', label: 'Cok → Bir (N:1)', desc: 'Ornek: Fatura satirlari → Cari kart' },
  { value: 'one_to_one', label: 'Bir → Bir (1:1)', desc: 'Ornek: Kullanici → Profil' },
  { value: 'many_to_many', label: 'Cok → Cok (N:N)', desc: 'Ornek: Urun → Kategori' },
]

export default function Relations() {
  const [datasources, setDatasources] = useState([])
  const [selectedDs, setSelectedDs] = useState(null)
  const [schema, setSchema] = useState(null)
  const [relations, setRelations] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({ from_table: '', from_column: '', to_table: '', to_column: '', relation_type: 'many_to_one' })
  const [searchRel, setSearchRel] = useState('')

  // Secilen tablonun kolonlarini almak icin
  const [fromColumns, setFromColumns] = useState([])
  const [toColumns, setToColumns] = useState([])
  const [fromTableSearch, setFromTableSearch] = useState('')
  const [toTableSearch, setToTableSearch] = useState('')
  const [fromColSearch, setFromColSearch] = useState('')
  const [toColSearch, setToColSearch] = useState('')
  const [fromTableOpen, setFromTableOpen] = useState(false)
  const [toTableOpen, setToTableOpen] = useState(false)
  const [fromColOpen, setFromColOpen] = useState(false)
  const [toColOpen, setToColOpen] = useState(false)

  useEffect(() => { loadDatasources() }, [])

  const loadDatasources = async () => {
    try { const { data } = await api.get('/datasources'); setDatasources(data) } catch (e) {}
  }

  const selectDs = async (dsId) => {
    setSelectedDs(dsId)
    try {
      const [schemaRes, relRes] = await Promise.all([
        api.get(`/datasources/${dsId}/schema`),
        api.get(`/datasources/${dsId}/relations`),
      ])
      setSchema(schemaRes.data)
      setRelations(relRes.data)
    } catch (e) { toast.error('Yuklenemedi') }
  }

  const autoDetect = async () => {
    if (!selectedDs) return
    try {
      toast.loading('Iliskiler algilaniyor...', { id: 'detect' })
      const { data } = await api.post(`/datasources/${selectedDs}/relations/auto-detect`)
      toast.success(`${data.detected} iliski algilandi`, { id: 'detect' })
      const relRes = await api.get(`/datasources/${selectedDs}/relations`)
      setRelations(relRes.data)
    } catch (e) { toast.error('Algilama basarisiz', { id: 'detect' }) }
  }

  const deleteAllRelations = async () => {
    if (!selectedDs) return
    if (!confirm(`Tum iliskiler silinecek (${relations.length} adet). Emin misiniz?`)) return
    try {
      const { data } = await api.delete(`/datasources/${selectedDs}/relations/all`)
      toast.success(`${data.deleted} iliski silindi`)
      setRelations([])
    } catch (e) { toast.error('Silinemedi') }
  }

  const createRelation = async (e) => {
    e.preventDefault()
    try {
      await api.post(`/datasources/${selectedDs}/relations`, form)
      toast.success('Iliski eklendi')
      setShowForm(false)
      const relRes = await api.get(`/datasources/${selectedDs}/relations`)
      setRelations(relRes.data)
    } catch (e) { toast.error('Eklenemedi') }
  }

  const deleteRelation = async (id) => {
    try {
      await api.delete(`/datasources/${selectedDs}/relations/${id}`)
      toast.success('Silindi')
      setRelations(relations.filter(r => r.id !== id))
    } catch (e) { toast.error('Silinemedi') }
  }

  // Tablo secilince kolonlarini getir
  const onFromTableChange = (tableName) => {
    setForm({ ...form, from_table: tableName, from_column: '' })
    const t = schema?.tables.find(t => t.name === tableName)
    setFromColumns(t?.columns || [])
  }
  const onToTableChange = (tableName) => {
    setForm({ ...form, to_table: tableName, to_column: '' })
    const t = schema?.tables.find(t => t.name === tableName)
    setToColumns(t?.columns || [])
  }

  const filteredRelations = relations.filter(r =>
    r.from_table.toLowerCase().includes(searchRel.toLowerCase()) ||
    r.to_table.toLowerCase().includes(searchRel.toLowerCase()) ||
    r.from_column.toLowerCase().includes(searchRel.toLowerCase()) ||
    r.to_column.toLowerCase().includes(searchRel.toLowerCase())
  )
  // Sayfalama — max 50 goster donmasin
  const [relPage, setRelPage] = useState(0)
  const REL_PAGE_SIZE = 50
  const pagedRelations = filteredRelations.slice(relPage * REL_PAGE_SIZE, (relPage + 1) * REL_PAGE_SIZE)
  const relTotalPages = Math.ceil(filteredRelations.length / REL_PAGE_SIZE)

  return (
    <div className="h-full flex flex-col">
      {/* Ust bar */}
      <div className="bg-white border-b px-6 py-3 flex items-center justify-between flex-shrink-0">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Tablo Iliskileri</h1>
          <p className="text-xs text-gray-400">Tablolar arasindaki baglantilari tanimlayin — raporlarda otomatik JOIN yapilir</p>
        </div>
        <div className="flex items-center gap-2">
          <select value={selectedDs || ''} onChange={(e) => e.target.value && selectDs(parseInt(e.target.value))}
            className="px-3 py-1.5 border rounded-lg text-sm">
            <option value="">Veri Kaynagi Secin</option>
            {datasources.map(ds => <option key={ds.id} value={ds.id}>{ds.name}</option>)}
          </select>
          {selectedDs && (
            <>
              {relations.length > 0 && (
                <button onClick={deleteAllRelations} className="flex items-center gap-1 text-xs px-3 py-1.5 bg-red-500 text-white rounded-lg hover:bg-red-600">
                  <FiTrash2 size={12} /> Tumunu Sil ({relations.length})
                </button>
              )}
              <button onClick={autoDetect} className="flex items-center gap-1 text-xs px-3 py-1.5 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600">
                <FiZap size={12} /> Otomatik Algila
              </button>
              <button onClick={() => { setShowForm(true); setForm({ from_table: '', from_column: '', to_table: '', to_column: '', relation_type: 'many_to_one' }) }}
                className="flex items-center gap-1 text-xs px-3 py-1.5 bg-primary-600 text-white rounded-lg hover:bg-primary-700">
                <FiPlus size={12} /> Iliski Ekle
              </button>
            </>
          )}
        </div>
      </div>

      {selectedDs ? (
        <div className="flex-1 overflow-auto p-6">
          {/* Arama */}
          <div className="mb-4 relative max-w-sm">
            <FiSearch size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-300" />
            <input value={searchRel} onChange={(e) => setSearchRel(e.target.value)} placeholder="Tablo veya kolon ara..."
              className="w-full pl-9 pr-3 py-2 border rounded-lg text-sm" />
          </div>

          {/* Iliski Listesi */}
          {filteredRelations.length > 0 ? (
            <div className="space-y-2">
              {pagedRelations.map(r => (
                <div key={r.id} className="bg-white rounded-xl border p-4 flex items-center gap-4 hover:shadow-sm transition-shadow">
                  {/* Sol tablo */}
                  <div className="flex items-center gap-2 min-w-[180px]">
                    <FiDatabase size={14} className="text-primary-500 flex-shrink-0" />
                    <div>
                      <div className="text-sm font-medium text-gray-800">{r.from_table}</div>
                      <div className="text-xs text-gray-400">{r.from_column}</div>
                    </div>
                  </div>

                  {/* Ok ve iliski tipi */}
                  <div className="flex items-center gap-2">
                    <div className="w-12 h-px bg-gray-300" />
                    <span className={`text-[10px] px-2 py-0.5 rounded-full border whitespace-nowrap ${
                      r.relation_type === 'many_to_one' ? 'bg-blue-50 text-blue-600 border-blue-200' :
                      r.relation_type === 'one_to_one' ? 'bg-green-50 text-green-600 border-green-200' :
                      'bg-purple-50 text-purple-600 border-purple-200'
                    }`}>
                      {RELATION_TYPES.find(t => t.value === r.relation_type)?.label || r.relation_type}
                    </span>
                    <FiArrowRight size={14} className="text-gray-400" />
                    <div className="w-12 h-px bg-gray-300" />
                  </div>

                  {/* Sag tablo */}
                  <div className="flex items-center gap-2 min-w-[180px]">
                    <FiDatabase size={14} className="text-green-500 flex-shrink-0" />
                    <div>
                      <div className="text-sm font-medium text-gray-800">{r.to_table}</div>
                      <div className="text-xs text-gray-400">{r.to_column}</div>
                    </div>
                  </div>

                  {/* Sil */}
                  <button onClick={() => deleteRelation(r.id)} className="ml-auto p-1 text-gray-300 hover:text-red-500">
                    <FiTrash2 size={14} />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-xl border border-dashed p-12 text-center">
              <FiDatabase size={32} className="mx-auto text-gray-300 mb-3" />
              <p className="text-sm text-gray-400 mb-2">Henuz iliski tanimlanmamis</p>
              <p className="text-xs text-gray-300 mb-4">"Otomatik Algila" ile ortak kolonlari bulsun veya manuel ekleyin</p>
              <button onClick={autoDetect} className="text-xs px-4 py-2 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600">
                <FiZap className="inline mr-1" size={12} /> Otomatik Algila
              </button>
            </div>
          )}

          {/* Sayfalama */}
          {relTotalPages > 1 && (
            <div className="mt-3 flex items-center justify-between text-xs text-gray-500">
              <span>{filteredRelations.length} iliski</span>
              <div className="flex items-center gap-2">
                <button onClick={() => setRelPage(p => Math.max(0, p - 1))} disabled={relPage === 0} className="px-2 py-1 border rounded hover:bg-gray-100 disabled:opacity-30">Onceki</button>
                <span>{relPage + 1} / {relTotalPages}</span>
                <button onClick={() => setRelPage(p => Math.min(relTotalPages - 1, p + 1))} disabled={relPage >= relTotalPages - 1} className="px-2 py-1 border rounded hover:bg-gray-100 disabled:opacity-30">Sonraki</button>
              </div>
            </div>
          )}
          {relTotalPages <= 1 && (
            <div className="mt-3 text-xs text-gray-400">{filteredRelations.length} iliski tanimli</div>
          )}
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center text-gray-300">
          <div className="text-center">
            <FiDatabase size={40} className="mx-auto mb-3" />
            <p className="text-sm">Ust taraftan bir veri kaynagi secin</p>
          </div>
        </div>
      )}

      {/* Iliski Ekleme Modal */}
      {showForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowForm(false)}>
          <form onSubmit={createRelation} onClick={(e) => e.stopPropagation()} className="bg-white rounded-xl p-6 w-full max-w-lg shadow-xl">
            <h2 className="text-lg font-semibold mb-4">Yeni Iliski</h2>

            <div className="grid grid-cols-2 gap-4 mb-4">
              {/* Sol - Kaynak tablo */}
              <div className="space-y-2">
                <label className="block text-xs font-medium text-gray-600">Kaynak Tablo {form.from_table && <span className="text-primary-600">({form.from_table})</span>}</label>
                <div className="relative">
                  <input value={fromTableSearch} onChange={(e) => { setFromTableSearch(e.target.value); setFromTableOpen(true) }}
                    onFocus={() => setFromTableOpen(true)}
                    placeholder="Tablo ara veya sec..." className="w-full px-3 py-2 border rounded-lg text-sm" />
                  {form.from_table && <button onClick={() => { setForm({ ...form, from_table: '', from_column: '' }); setFromColumns([]) }} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-red-500"><FiX size={12} /></button>}
                  {fromTableOpen && (
                    <div className="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                      {(schema?.tables || []).filter(t => !fromTableSearch || t.name.toLowerCase().includes(fromTableSearch.toLowerCase())).slice(0, 30).map(t => (
                        <button type="button" key={t.id} onClick={() => { onFromTableChange(t.name); setFromTableSearch(''); setFromTableOpen(false) }}
                          className={`block w-full text-left px-3 py-1.5 text-sm hover:bg-primary-50 ${form.from_table === t.name ? 'bg-primary-50 text-primary-700 font-medium' : ''}`}>{t.name}</button>
                      ))}
                      {(schema?.tables || []).filter(t => !fromTableSearch || t.name.toLowerCase().includes(fromTableSearch.toLowerCase())).length === 0 && (
                        <p className="px-3 py-2 text-xs text-gray-400">Sonuc yok</p>
                      )}
                    </div>
                  )}
                </div>
                <label className="block text-xs font-medium text-gray-600">Kaynak Kolon {form.from_column && <span className="text-primary-600">({form.from_column})</span>}</label>
                <div className="relative">
                  <input value={fromColSearch} onChange={(e) => { setFromColSearch(e.target.value); setFromColOpen(true) }}
                    onFocus={() => setFromColOpen(true)}
                    placeholder={form.from_table ? 'Kolon ara...' : 'Once tablo sec'} disabled={!form.from_table} className="w-full px-3 py-2 border rounded-lg text-sm disabled:bg-gray-100" />
                  {form.from_column && <button onClick={() => setForm({ ...form, from_column: '' })} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-red-500"><FiX size={12} /></button>}
                  {fromColOpen && form.from_table && (
                    <div className="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                      {fromColumns.filter(c => !fromColSearch || c.name.toLowerCase().includes(fromColSearch.toLowerCase())).map(c => (
                        <button type="button" key={c.id} onClick={() => { setForm({ ...form, from_column: c.name }); setFromColSearch(''); setFromColOpen(false) }}
                          className={`block w-full text-left px-3 py-1.5 text-sm hover:bg-primary-50 ${form.from_column === c.name ? 'bg-primary-50 text-primary-700 font-medium' : ''}`}>{c.name}</button>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Sag - Hedef tablo */}
              <div className="space-y-2">
                <label className="block text-xs font-medium text-gray-600">Hedef Tablo {form.to_table && <span className="text-green-600">({form.to_table})</span>}</label>
                <div className="relative">
                  <input value={toTableSearch} onChange={(e) => { setToTableSearch(e.target.value); setToTableOpen(true) }}
                    onFocus={() => setToTableOpen(true)}
                    placeholder="Tablo ara veya sec..." className="w-full px-3 py-2 border rounded-lg text-sm" />
                  {form.to_table && <button onClick={() => { setForm({ ...form, to_table: '', to_column: '' }); setToColumns([]) }} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-red-500"><FiX size={12} /></button>}
                  {toTableOpen && (
                    <div className="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                      {(schema?.tables || []).filter(t => !toTableSearch || t.name.toLowerCase().includes(toTableSearch.toLowerCase())).slice(0, 30).map(t => (
                        <button type="button" key={t.id} onClick={() => { onToTableChange(t.name); setToTableSearch(''); setToTableOpen(false) }}
                          className={`block w-full text-left px-3 py-1.5 text-sm hover:bg-primary-50 ${form.to_table === t.name ? 'bg-primary-50 text-primary-700 font-medium' : ''}`}>{t.name}</button>
                      ))}
                    </div>
                  )}
                </div>
                <label className="block text-xs font-medium text-gray-600">Hedef Kolon {form.to_column && <span className="text-green-600">({form.to_column})</span>}</label>
                <div className="relative">
                  <input value={toColSearch} onChange={(e) => { setToColSearch(e.target.value); setToColOpen(true) }}
                    onFocus={() => setToColOpen(true)}
                    placeholder={form.to_table ? 'Kolon ara...' : 'Once tablo sec'} disabled={!form.to_table} className="w-full px-3 py-2 border rounded-lg text-sm disabled:bg-gray-100" />
                  {form.to_column && <button onClick={() => setForm({ ...form, to_column: '' })} className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-300 hover:text-red-500"><FiX size={12} /></button>}
                  {toColOpen && form.to_table && (
                    <div className="absolute z-20 w-full mt-1 bg-white border rounded-lg shadow-lg max-h-48 overflow-y-auto">
                      {toColumns.filter(c => !toColSearch || c.name.toLowerCase().includes(toColSearch.toLowerCase())).map(c => (
                        <button type="button" key={c.id} onClick={() => { setForm({ ...form, to_column: c.name }); setToColSearch(''); setToColOpen(false) }}
                          className={`block w-full text-left px-3 py-1.5 text-sm hover:bg-primary-50 ${form.to_column === c.name ? 'bg-primary-50 text-primary-700 font-medium' : ''}`}>{c.name}</button>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Iliski tipi */}
            <div className="mb-4">
              <label className="block text-xs font-medium text-gray-600 mb-1">Iliski Tipi</label>
              {RELATION_TYPES.map(rt => (
                <label key={rt.value} className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer mb-1 ${form.relation_type === rt.value ? 'bg-primary-50 border border-primary-200' : 'hover:bg-gray-50'}`}>
                  <input type="radio" name="rel_type" value={rt.value} checked={form.relation_type === rt.value}
                    onChange={(e) => setForm({ ...form, relation_type: e.target.value })} />
                  <div>
                    <span className="text-sm font-medium text-gray-700">{rt.label}</span>
                    <span className="text-xs text-gray-400 ml-2">{rt.desc}</span>
                  </div>
                </label>
              ))}
            </div>

            <div className="flex gap-2 justify-end">
              <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Iptal</button>
              <button type="submit" className="px-4 py-2 text-sm bg-primary-600 text-white rounded-lg hover:bg-primary-700">Ekle</button>
            </div>
          </form>
        </div>
      )}
    </div>
  )
}
